'use client';

import { useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { HeroBanner } from '@/components/frontend/common/hero-banner';

export function RefundPolicyPageContent() {
    const t = useTranslations('refundPolicyPage');

    return (
        <div className="min-h-screen bg-white dark:bg-black">
            <HeroBanner
                page="refund-policy"
                title={t('title')}
                description={t('description')}
                pill={t('pill')}
                className="border-b border-gray-200 dark:border-gray-900"
            />

            <SectionWrapper variant="default" padding="md" className="relative overflow-hidden">
                {/* Decorative background */}
                <div className="pointer-events-none absolute inset-0 opacity-40">
                    <div className="absolute left-10 top-10 h-80 w-80 rounded-full bg-primary-500/10 blur-3xl" />
                    <div className="absolute right-10 bottom-10 h-80 w-80 rounded-full bg-blue-500/10 blur-3xl" />
                </div>

                <div className="relative z-10 container">
                    <div className="prose prose-lg dark:prose-invert max-w-none">
                        <p className="text-gray-700 dark:text-gray-300 mb-8">
                            {t('intro')}
                        </p>

                        <p className="text-gray-700 dark:text-gray-300 mb-8">
                            {t('exceptionalCircumstances')}
                        </p>

                        {/* Money-Back Guarantee Section */}
                        <section className="mb-8">
                            <p className="text-gray-700 dark:text-gray-300 mb-4">
                                {t('moneyBackGuarantee.description')}
                            </p>
                            <p className="text-gray-700 dark:text-gray-300 mb-4">
                                {t('moneyBackGuarantee.honorBased')}
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300 mb-4 ml-4">
                                <li>{t('moneyBackGuarantee.condition1')}</li>
                                <li>{t('moneyBackGuarantee.condition2')}</li>
                                <li>{t('moneyBackGuarantee.condition3')}</li>
                                <li>{t('moneyBackGuarantee.condition4')}</li>
                            </ul>
                        </section>

                        {/* Product Return Procedure Section */}
                        <section className="mb-8">
                            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-4">
                                {t('returnProcedure.title')}
                            </h2>
                            <p className="text-gray-700 dark:text-gray-300 mb-4">
                                {t('returnProcedure.subtitle')}
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300 mb-4 ml-4">
                                <li>{t('returnProcedure.requirement1')}</li>
                                <li>{t('returnProcedure.requirement2')}</li>
                                <li>{t('returnProcedure.requirement3')}</li>
                            </ul>
                            <p className="text-gray-700 dark:text-gray-300 mb-4">
                                {t('returnProcedure.responseTime')}
                            </p>
                            <p className="text-gray-700 dark:text-gray-300">
                                {t('returnProcedure.emailInfo')}
                            </p>
                        </section>
                    </div>
                </div>
            </SectionWrapper>
        </div>
    );
}

